(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evergreen-countdown-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  const selector = '[data-eg-countdown-bar]';

  function initCountdown(section) {
    if (section.egCountdownCleanup) section.egCountdownCleanup();
    const timer = section.querySelector('.eg-countdown-timer');
    if (!timer) return;

    const duration = Number(timer.dataset.durationMs);
    const isReal = timer.dataset.timerMode === 'real';
    const hideOnExpiry = timer.dataset.hideOnExpiry === 'true';
    const storageKey = 'tg_evergreen_countdown_end_time_' + section.dataset.sectionId + '_' + duration;
    let endTime;
    let startTime = 0;
    let intervalId;

    if (!Number.isFinite(duration) || duration <= 0) {
      section.hidden = isReal;
      return;
    }

    if (isReal) {
      const start = (timer.dataset.realStart || '').trim();
      const match = /^(\d{4})-(\d{2})-(\d{2})T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(Z|[+-](?:0\d|1[0-4]):[0-5]\d)$/.exec(start);
      startTime = Date.parse(start);
      const calendar = match && new Date(start.slice(0, 10) + 'T00:00:00Z');
      if (!match || !Number.isFinite(startTime) || !Number.isFinite(calendar.getTime()) || calendar.toISOString().slice(0, 10) !== start.slice(0, 10)) {
        section.hidden = true;
        if (window.Shopify && window.Shopify.designMode) {
          console.warn('Countdown: enter a valid real start date with a timezone, for example 2026-09-21T09:00:00+10:00.');
        }
        return;
      }
      endTime = startTime + duration;
    } else {
      try {
        endTime = Number(localStorage.getItem(storageKey));
      } catch (error) {
        endTime = 0;
      }
    }

    const monthsDesktop = section.querySelector("[data-months-desktop]");
    const weeksDesktop = section.querySelector("[data-weeks-desktop]");
    const daysDesktop = section.querySelector("[data-days-desktop]");
    const hoursDesktop = section.querySelector("[data-hours-desktop]");
    const minutesDesktop = section.querySelector("[data-minutes-desktop]");
    const secondsDesktop = section.querySelector("[data-seconds-desktop]");

    const monthsMobile = section.querySelector("[data-months-mobile]");
    const weeksMobile = section.querySelector("[data-weeks-mobile]");
    const daysMobile = section.querySelector("[data-days-mobile]");
    const hoursMobile = section.querySelector("[data-hours-mobile]");
    const minutesMobile = section.querySelector("[data-minutes-mobile]");
    const secondsMobile = section.querySelector("[data-seconds-mobile]");

    const MONTH_SECONDS = 30 * 24 * 60 * 60;
    const WEEK_SECONDS = 7 * 24 * 60 * 60;
    const DAY_SECONDS = 24 * 60 * 60;
    const HOUR_SECONDS = 60 * 60;

    function getEndTime(now) {
      if (!isReal && (!Number.isFinite(endTime) || endTime <= now)) {
        endTime = now + duration;
        try {
          localStorage.setItem(storageKey, String(endTime));
        } catch (error) {
        }
      }
      return endTime;
    }

    function setText(el, value) {
      if (el) el.textContent = String(value).padStart(2, '0');
    }

    function cleanup() {
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', updateTimer);
      window.removeEventListener('pageshow', updateTimer);
      delete section.egCountdownCleanup;
    }

    function updateTimer() {
      if (!section.isConnected) {
        cleanup();
        return;
      }
      const now = Date.now();
      const remaining = Math.max(0, getEndTime(now) - now);
      section.hidden = isReal && (now < startTime || (remaining === 0 && hideOnExpiry));
      if (isReal && remaining === 0) clearInterval(intervalId);

      let totalSeconds = Math.ceil(remaining / 1000);

      let months = 0;
      let weeks = 0;

      if (monthsDesktop || monthsMobile) {
        months = Math.floor(totalSeconds / MONTH_SECONDS);
        totalSeconds = totalSeconds % MONTH_SECONDS;
      }

      if (weeksDesktop || weeksMobile) {
        weeks = Math.floor(totalSeconds / WEEK_SECONDS);
        totalSeconds = totalSeconds % WEEK_SECONDS;
      }

      const days = Math.floor(totalSeconds / DAY_SECONDS);
      totalSeconds = totalSeconds % DAY_SECONDS;

      const hours = Math.floor(totalSeconds / HOUR_SECONDS);
      totalSeconds = totalSeconds % HOUR_SECONDS;

      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      setText(monthsDesktop, months);
      setText(weeksDesktop, weeks);
      setText(daysDesktop, days);
      setText(hoursDesktop, hours);
      setText(minutesDesktop, minutes);
      setText(secondsDesktop, seconds);

      setText(monthsMobile, months);
      setText(weeksMobile, weeks);
      setText(daysMobile, days);
      setText(hoursMobile, hours);
      setText(minutesMobile, minutes);
      setText(secondsMobile, seconds);
    }

    section.egCountdownCleanup = cleanup;
    intervalId = setInterval(updateTimer, 1000);
    document.addEventListener('visibilitychange', updateTimer);
    window.addEventListener('pageshow', updateTimer);
    updateTimer();
  }

  function initAll(root) {
    root.querySelectorAll(selector).forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function(event) {
    event.target.querySelectorAll(selector).forEach(function(section) {
      if (section.egCountdownCleanup) section.egCountdownCleanup();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gfills-bundle-page"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gfills-journey')) {
  customElements.define('gfills-journey', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.config = JSON.parse(this.querySelector('[data-gfills-config]').textContent);
      this.t = this.config.strings;
      this.currency = new Intl.NumberFormat(this.config.locale || 'en', {style:'currency', currency:this.config.currency || 'AUD'});
      this.initial = this.config.variants.find(v => v.id === this.config.initialVariant) || this.config.variants[0];
      this.bundle = this.config.bundles.find(b => b.id === this.config.defaultBundle) || this.config.bundles[0];
      this.selections = new Map(this.config.bundles.map(b => [b.id, Array.from({length:b.quantity}, () => b.quantity > 1 && !this.config.hasOnlyDefaultVariant ? null : this.initial)]));
      this.querySelectorAll('[data-style-select]').forEach(select => {
        const bundle = this.config.bundles.find(b => b.id === select.dataset.bundle);
        select.value = bundle.quantity > 1 ? '' : this.initial?.options[Number(select.dataset.option)] || '';
      });
      this.track = this.querySelector('[data-gallery-track]');
      this.index = 0;
      this.listen(this, 'click', e => this.onClick(e));
      this.listen(this, 'change', e => this.onChange(e));
      this.listen(this, 'keydown', e => this.onKey(e));
      this.listen(this.track, 'scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.syncGallery());
      });
      this.listen(this.track, 'pointerdown', e => {
        if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('video,iframe,model-viewer,button,a')) return;
        this.drag = {start:e.clientX, left:this.track.scrollLeft, id:e.pointerId, moved:false};
        this.track.setPointerCapture(e.pointerId);
      });
      this.listen(this.track, 'pointermove', e => {
        if (!this.drag) return;
        const dx = e.clientX - this.drag.start;
        if (Math.abs(dx) > 5) this.drag.moved = true;
        if (!this.drag.moved) return;
        this.track.classList.add('is-dragging');
        this.track.scrollLeft = this.drag.left - dx;
        e.preventDefault();
      });
      const finishDrag = () => {
        if (!this.drag) return;
        this.drag = null;
        this.track.classList.remove('is-dragging');
        this.goTo(Math.round(this.track.scrollLeft / (this.track.clientWidth || 1)));
      };
      this.listen(this.track, 'pointerup', finishDrag);
      this.listen(this.track, 'pointercancel', finishDrag);
      this.listen(this.track, 'lostpointercapture', finishDrag);
      this.listen(this.track, 'dragstart', e => e.preventDefault());
      this.listen(document, 'shopify:block:select', e => {
        if (this.config.bundles.some(b => b.id === e.detail.blockId)) this.selectBundle(e.detail.blockId);
      });
      this.resize = new ResizeObserver(() => this.goTo(this.index, false));
      this.resize.observe(this.track);
      if (this.bundle) this.selectBundle(this.bundle.id);
      else this.update();
    }
    disconnectedCallback() {
      this.events?.abort(); this.events = null;
      this.resize?.disconnect(); cancelAnimationFrame(this.scrollFrame);
    }
    listen(target, name, handler) {target.addEventListener(name, handler, {signal:this.events.signal});}
    money(cents) {return this.currency.format(cents / 100);}
    phrase(key, values = {}) {return Object.entries(values).reduce((s,[k,v]) => s.replaceAll(`{${k}}`, String(v)), this.t[key] || key);}
    get planId() {return this.querySelector('[data-selling-plan]:checked')?.value || '';}
    calculate(bundle, planId = this.planId, preview = false) {
      const selections = this.selections.get(bundle.id) || [];
      const variants = preview ? selections.map(v => v === null ? this.initial : v) : selections;
      if (variants.length !== bundle.quantity || variants.some(v => !v)) return {valid:false};
      const allocations = variants.map(v => planId ? v.plans.find(p => String(p.id) === planId) : {price:v.price});
      if (allocations.some(p => !p)) return {valid:false};
      const bases = allocations.map(p => p.price);
      const discounts = bases.map(() => 0);
      const percentages = bases.map(() => 0);
      if (!planId || this.config.subscriptionBundles) {
        if (bases.length >= 2) {
          const target = bundle.discountMode === 'cheapest' && bases.length === 2 ? (bases[0] < bases[1] ? 0 : 1) : 1;
          percentages[target] = Number(bundle.discount2) || 0;
        }
        if (bases.length >= 3) percentages[2] = Number(bundle.discount3) || 0;
      }
      percentages.forEach((percent,i) => {discounts[i] = Math.round(bases[i] * percent / 100);});
      const reference = variants.reduce((sum,v) => sum + v.price, 0);
      const total = bases.reduce((sum,price,i) => sum + price - discounts[i], 0);
      return {valid:variants.every(v => v.available), variants, reference, total, savings:reference-total, subscription:reference-bases.reduce((sum,p) => sum+p,0), discounts, percentages};
    }
    selectBundle(id) {
      const bundle = this.config.bundles.find(b => b.id === id);
      if (!bundle) return;
      this.bundle = bundle;
      this.querySelectorAll('[data-bundle-tab]').forEach(tab => {
        const selected = tab.dataset.bundleTab === id;
        tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1;
      });
      this.querySelectorAll('[data-bundle-panel]').forEach(panel => {panel.hidden = panel.dataset.bundlePanel !== id;});
      this.querySelector('[data-message]').textContent = '';
      this.buildGallery(); this.update();
    }
    updatePurchaseOptions() {
      if (!this.bundle) return;
      this.querySelectorAll('[data-plan-card]').forEach(card => {
        const input = card.querySelector('[data-selling-plan]');
        const result = this.calculate(this.bundle, input.value, true);
        input.disabled = Boolean(this.busy) || !result.valid;
        card.classList.toggle('is-selected', input.checked);
        card.classList.toggle('is-unavailable', !result.valid);
        card.querySelector('[data-plan-price]').textContent = result.valid ? this.money(result.total) : this.t.unavailable;
        const saving = card.querySelector('[data-plan-saving]');
        saving.hidden = !result.valid || !(result.savings > 0);
        const percent = result.reference > 0 ? Math.round(result.savings / result.reference * 1000) / 10 : 0;
        saving.textContent = saving.hidden ? '' : this.phrase('planSaving', {percent, amount:this.money(result.savings)});
      });
    }
    update() {
      this.updatePurchaseOptions();
      this.config.bundles.forEach(bundle => {
        const result = this.calculate(bundle, this.planId, true);
        this.querySelector(`[data-tab-price="${bundle.id}"]`).textContent = result.total === undefined ? this.t.unavailable : this.money(result.total / bundle.quantity);
        (this.selections.get(bundle.id) || []).forEach((v,i) => {
          const summary = this.querySelector(`[data-style-summary="${bundle.id}-${i+1}"]`);
          if (summary) summary.textContent = v ? (v.options[0] === 'Default Title' ? '' : v.options.join(' · ')) + (!v.available ? ` · ${this.t.soldOut}` : '') : v === null ? this.t.chooseStyle : this.t.unavailable;
        });
        const list = this.querySelector(`[data-offers="${bundle.id}"]`);
        list.replaceChildren();
        if (result.total !== undefined) {
          result.percentages.forEach((percent,i) => {
            if (percent <= 0) return;
            const row = document.createElement('li'), tick = document.createElement('span'), text = document.createElement('span'), strong = document.createElement('strong'), pill = document.createElement('span');
            tick.textContent = '✓'; tick.setAttribute('aria-hidden','true');
            strong.textContent = this.phrase('percentOff',{percent});
            text.append(strong, document.createTextNode(' ' + this.phrase('yourItem',{ordinal:this.t.ordinals[i],product:this.config.unitLabel})));
            pill.className = 'gf-pill'; pill.textContent = this.phrase('saving',{amount:this.money(result.discounts[i])}); text.append(pill);
            row.append(tick,text); list.append(row);
          });
          if (result.subscription > 0) {
            const row = document.createElement('li'), tick = document.createElement('span'), text = document.createElement('span');
            tick.textContent = '✓';tick.setAttribute('aria-hidden','true');text.textContent = this.phrase('subscriptionSaving',{amount:this.money(result.subscription)});row.append(tick,text);list.append(row);
          }
        }
      });
      const result = this.bundle ? this.calculate(this.bundle, this.planId, true) : {valid:false};
      const purchase = this.bundle ? this.calculate(this.bundle) : {valid:false};
      const needsChoices = this.bundle && (this.selections.get(this.bundle.id) || []).some(v => v === null);
      this.querySelector('[data-top-price]').textContent = result.total === undefined ? this.t.unavailable : this.money(result.total);
      const compare = this.querySelector('[data-top-compare]'), saving = this.querySelector('[data-top-saving]');
      compare.hidden = saving.hidden = !(this.config.showCompare && result.savings > 0);
      compare.textContent = result.reference === undefined ? '' : this.money(result.reference);
      saving.textContent = result.savings > 0 ? this.phrase('save',{amount:this.money(result.savings)}) : '';
      const add = this.querySelector('[data-add]');
      add.disabled = this.busy || !purchase.valid || (this.config.requiresPlan && !this.planId);
      add.textContent = this.busy ? this.t.adding : needsChoices ? this.t.chooseStyles : purchase.valid ? `${this.config.atcLabel} · ${this.bundle.title} · ${this.money(result.total)}` : this.t.unavailable;
      const editorNote = this.querySelector('[data-editor-note]');
      if (editorNote) {editorNote.hidden = false;editorNote.textContent = this.t.editorNote;}
    }
    onClick(e) {
      const tab = e.target.closest('[data-bundle-tab]');
      if (tab) this.selectBundle(tab.dataset.bundleTab);
      if (e.target.closest('[data-gallery-prev]')) this.goTo(this.index-1);
      if (e.target.closest('[data-gallery-next]')) this.goTo(this.index+1);
      const thumb = e.target.closest('[data-gallery-index]');
      if (thumb) this.goTo(Number(thumb.dataset.galleryIndex));
      if (e.target.closest('[data-add]')) this.addToCart();
    }
    onChange(e) {
      if (e.target.matches('[data-selling-plan]')) {this.update();return;}
      if (!e.target.matches('[data-style-select]')) return;
      const {bundle,slot} = e.target.dataset;
      const options = [...this.querySelectorAll(`[data-style-select][data-bundle="${bundle}"][data-slot="${slot}"]`)].map(select => select.value);
      const variant = options.some(value => value === '') ? null : this.config.variants.find(v => v.options.every((value,i) => value === options[i]));
      this.selections.get(bundle)[Number(slot)-1] = variant;
      this.update();
      if (Number(slot) === 1 && !this.querySelector(`[data-bundle-media="${bundle}"]`) && variant?.mediaId) {
        const index = this.galleryItems.findIndex(item => item.dataset.mediaId === String(variant.mediaId));
        if (index >= 0) this.goTo(index);
      }
    }
    onKey(e) {
      if (e.target.matches('[data-bundle-tab]') && ['ArrowRight','ArrowLeft','Home','End'].includes(e.key)) {
        const tabs = [...this.querySelectorAll('[data-bundle-tab]')], index = tabs.indexOf(e.target);
        const next = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length-1 : (index + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length)%tabs.length;
        e.preventDefault();this.selectBundle(tabs[next].dataset.bundleTab);tabs[next].focus();
      }
      if (e.target === this.track && ['ArrowRight','ArrowLeft'].includes(e.key)) {e.preventDefault();this.goTo(this.index + (e.key === 'ArrowRight' ? 1 : -1));}
    }
    buildGallery() {
      this.track.querySelectorAll('video').forEach(video => video.pause());
      const hero = this.querySelector(`[data-bundle-media="${this.bundle.id}"]`);
      this.galleryItems = [...(hero ? [hero] : []), ...this.querySelectorAll('template[data-media-id]')];
      this.track.replaceChildren();
      const thumbnails = this.querySelector('[data-gallery-thumbnails]');thumbnails.replaceChildren();
      this.galleryItems.forEach((template,i) => {
        const slide = document.createElement('div');slide.className = 'gf-slide';slide.setAttribute('role','group');slide.setAttribute('aria-label',this.phrase('imageOf',{index:i+1,total:this.galleryItems.length}));slide.append(template.content.cloneNode(true));
        if (i === 0) slide.querySelector('img')?.setAttribute('loading','eager');this.track.append(slide);
        const thumb = document.createElement('button');thumb.type = 'button';thumb.dataset.galleryIndex = i;thumb.setAttribute('aria-label',this.phrase('viewImage',{index:i+1}));
        const img = document.createElement('img');img.src = template.dataset.thumbnail;img.alt = '';img.loading = 'lazy';thumb.append(img);thumbnails.append(thumb);
      });
      if (!this.galleryItems.length) {const empty = document.createElement('div');empty.className = 'gf-slide gf-empty';empty.textContent = this.t.noImages;this.track.append(empty);}
      this.goTo(0,false);
    }
    goTo(index, smooth = true) {
      this.index = Math.max(0,Math.min(index,(this.galleryItems?.length || 1)-1));
      this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth':'instant'});
      this.paintGallery();
    }
    syncGallery() {
      if (this.drag) return;
      const index = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
      if (index !== this.index) {this.index = index;this.paintGallery();}
    }
    paintGallery() {
      const total = this.galleryItems?.length || 0;
      this.querySelector('[data-gallery-counter]').textContent = `${total ? this.index+1 : 0} / ${total}`;
      this.querySelector('[data-gallery-prev]').disabled = this.index === 0;
      this.querySelector('[data-gallery-next]').disabled = this.index >= total-1;
      this.querySelectorAll('[data-gallery-index]').forEach((thumb,i) => {thumb.setAttribute('aria-current',String(i === this.index));});
      [...this.track.children].forEach((slide,i) => {
        slide.inert = i !== this.index;
        if (i !== this.index) slide.querySelectorAll('video').forEach(video => {if (!video.paused) video.pause();});
      });
    }
    async addToCart() {
      if (this.busy || !this.bundle) return;
      const result = this.calculate(this.bundle);
      if (!result.valid || (this.config.requiresPlan && !this.planId)) return;
      this.busy = true;this.update();const message = this.querySelector('[data-message]');message.textContent = '';
      const items = [];
      result.variants.forEach(variant => {
        const existing = items.find(item => item.id === variant.id);
        if (existing) existing.quantity++;
        else items.push({id:variant.id,quantity:1,...(this.planId ? {selling_plan:Number(this.planId)} : {})});
      });
      try {
        const response = await fetch(this.config.cartAddUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.t.cartError);
        try {
          if (typeof window.upcartRefreshCart === 'function') {
            try {await window.upcartRefreshCart();} catch {}
          }
          if (typeof window.upcartOpenCart !== 'function') throw new Error('Drawer unavailable');
          await window.upcartOpenCart();
        } catch {
          message.textContent = this.t.drawerUnavailable;
        }
        this.busy = false;this.update();
      } catch (error) {
        message.textContent = error.message || this.t.cartError;this.busy = false;this.update();
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super()
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      }
      this.querySelectorAll('a').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this))
      )
    }

    onItemClick(event) {
      event.preventDefault()
      const form = this.querySelector('form')
      this.elements.input.value = event.currentTarget.dataset.value
      if (form) form.submit()
    }
  }

  customElements.define('localization-form', LocalizationForm)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-hero-pro"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__guidelinerHeroSlideshow) return;
  window.__guidelinerHeroSlideshow = true;
  var instances = new Map();
  var saved = new Map();

  function mount(root) {
    if (instances.has(root)) return;
    var track = root.querySelector('[data-hero-track]');
    var slides = Array.from(track.querySelectorAll('[data-hero-slide]'));
    var controls = root.querySelector('[data-hero-controls]');
    var pauseButton = root.querySelector('[data-hero-pause]');
    var status = root.querySelector('[data-hero-status]');
    var id = root.dataset.heroCarousel;
    var previous = saved.get(id) || { index: 0, stopped: false, seen: false };
    var index = Math.min(previous.index, slides.length - 1);
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var desktop = window.matchMedia('(min-width: 1024px)');
    var stopped = previous.stopped || reduced.matches || !!(window.Shopify && window.Shopify.designMode);
    var visible = false;
    var seen = previous.seen;
    var leftViewport = false;
    var timer = null;
    var settling = null;
    var destroyed = false;
    var controller = new AbortController();
    var signal = controller.signal;

    function remember() { saved.set(id, { index: index, stopped: stopped, seen: seen }); }
    function clearTimer() { if (timer !== null) window.clearTimeout(timer); timer = null; }
    function stop() {
      stopped = true;
      clearTimer();
      pauseButton.disabled = true;
      pauseButton.setAttribute('aria-label', 'Automatic sliding paused');
      root.dataset.heroAutoplay = 'paused';
      remember();
    }
    function embedCommand(frame, play) {
      var src = frame.getAttribute('src');
      if (!src || !frame.contentWindow) return;
      try {
        var url = new URL(src, location.href);
        if (url.hostname === 'www.youtube.com' || url.hostname === 'www.youtube-nocookie.com') {
          frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: play ? 'playVideo' : 'pauseVideo', args: [] }), url.origin);
        } else if (url.hostname === 'player.vimeo.com') {
          frame.contentWindow.postMessage(JSON.stringify({ method: play ? 'play' : 'pause' }), url.origin);
        }
      } catch (error) {}
    }
    function syncMedia() {
      slides.forEach(function (slide, n) {
        slide.querySelectorAll('video, iframe').forEach(function (media) {
          var isMobile = media.classList.contains('hero-media-video-mobile') || media.classList.contains('hero-media-embed-mobile');
          var isDesktop = media.classList.contains('hero-media-video-desktop') || media.classList.contains('hero-media-embed-desktop');
          var viewportMatch = (!isMobile || !desktop.matches) && (!isDesktop || desktop.matches);
          var play = n === index && visible && !document.hidden && viewportMatch;
          if (play && media.dataset.src && !media.getAttribute('src')) {
            media.setAttribute('src', media.dataset.src);
            if (media.tagName === 'VIDEO') media.load();
          }
          if (media.tagName === 'VIDEO') {
            media.muted = true;
            if (play) {
              var promise = media.play();
              if (promise && promise.catch) promise.catch(function () {});
            } else media.pause();
          } else embedCommand(media, play);
        });
      });
    }
    function setActive(n, announce) {
      index = Math.max(0, Math.min(slides.length - 1, n));
      slides.forEach(function (slide, i) {
        slide.inert = i !== index;
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        slide.classList.toggle('is-active', i === index);
      });
      if (announce) status.textContent = 'Slide ' + (index + 1) + ' of ' + slides.length;
      remember();
      syncMedia();
    }
    function slideOffset(n) {
      var t = track.getBoundingClientRect();
      var s = slides[n].getBoundingClientRect();
      return track.scrollLeft + s.left - t.left;
    }
    function go(n, manual) {
      if (manual) stop();
      var target = (n + slides.length) % slides.length;
      var left = slideOffset(target);
      setActive(target, manual);
      track.scrollTo({ left: left, behavior: reduced.matches ? 'auto' : 'smooth' });
    }
    function schedule() {
  clearTimer();

  if (
    destroyed || stopped || !visible || document.hidden ||
    slides.length < 2 || root.dataset.heroAuto === 'false'
  ) return;

  timer = window.setTimeout(function () {
    timer = null;
    go(index === 0 ? 1 : 0, false);
    schedule();
  }, index === 0 ? 3000 : 5000);
}

    root.classList.add('ss-hero-ready');
    controls.hidden = slides.length < 2;
    root.dataset.heroAutoplay = stopped ? 'paused' : 'playing';
    if (stopped || root.dataset.heroAuto === 'false') stop();
    setActive(index, false);
    track.scrollTo({ left: slideOffset(index), behavior: 'auto' });

    track.addEventListener('pointerdown', function (event) {
      stop();
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a,button,input,select,textarea')) return;
      var startX = event.clientX;
      var startY = event.clientY;
      function finish(up) {
        document.removeEventListener('pointerup', finish);
        var dx = up.clientX - startX;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(up.clientY - startY)) go(index + (dx < 0 ? 1 : -1), true);
      }
      document.addEventListener('pointerup', finish, { once: true, signal: signal });
    }, { signal: signal });
    track.addEventListener('touchstart', stop, { passive: true, signal: signal });
    track.addEventListener('wheel', function (event) { if (Math.abs(event.deltaX) > 0) stop(); }, { passive: true, signal: signal });
    root.addEventListener('focusin', stop, { signal: signal });
    root.querySelector('[data-hero-prev]').addEventListener('click', function () { go(index - 1, true); }, { signal: signal });
    root.querySelector('[data-hero-next]').addEventListener('click', function () { go(index + 1, true); }, { signal: signal });
    pauseButton.addEventListener('click', stop, { signal: signal });
    track.addEventListener('keydown', function (event) {
      if (event.target.closest('input,textarea,select')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        go(index + (event.key === 'ArrowLeft' ? -1 : 1), true);
      }
    }, { signal: signal });
    track.addEventListener('scroll', function () {
      window.clearTimeout(settling);
      settling = window.setTimeout(function () {
        var edge = track.getBoundingClientRect().left;
        var nearest = slides.reduce(function (best, slide, n) {
          return Math.abs(slide.getBoundingClientRect().left - edge) < Math.abs(slides[best].getBoundingClientRect().left - edge) ? n : best;
        }, 0);
        setActive(nearest, stopped);
      }, 140);
    }, { passive: true, signal: signal });
    root.querySelectorAll('iframe').forEach(function (frame) { frame.addEventListener('load', syncMedia, { signal: signal }); });
    function resize() { track.scrollTo({ left: slideOffset(index), behavior: 'auto' }); syncMedia(); schedule(); }
    window.addEventListener('resize', resize, { signal: signal });
    document.addEventListener('visibilitychange', function () {
      clearTimer();
      syncMedia();
      if (!document.hidden) schedule();
    }, { signal: signal });
    function motionChanged() { if (reduced.matches) stop(); }
    reduced.addEventListener('change', motionChanged);
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var nextVisible = entry.isIntersecting && entry.intersectionRatio >= 0.15;
        if (nextVisible === visible) return;
        visible = nextVisible;
        if (visible) {
          if (leftViewport) stop();
          seen = true;
          remember();
          schedule();
        } else {
          if (seen) leftViewport = true;
          clearTimer();
        }
        syncMedia();
      });
    }, { threshold: [0, 0.15] });
    observer.observe(root);
    function selectEditorBlock(event) {
      var sectionNode = root.closest('.shopify-section');
      if (!(root.contains(event.target) || (sectionNode && sectionNode.contains(event.target)))) return;
      var blockId = event.detail && event.detail.blockId;
      var found = slides.findIndex(function (slide) { return slide.dataset.heroBlock === blockId; });
      go(found >= 0 ? found : 0, true);
    }
    document.addEventListener('shopify:block:select', selectEditorBlock, { signal: signal });
    instances.set(root, function () {
      destroyed = true;
      clearTimer();
      window.clearTimeout(settling);
      visible = false;
      syncMedia();
      observer.disconnect();
      reduced.removeEventListener('change', motionChanged);
      controller.abort();
      instances.delete(root);
    });
  }
  function mountWithin(scope) {
    if (scope.matches && scope.matches('[data-hero-carousel]')) mount(scope);
    scope.querySelectorAll('[data-hero-carousel]').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mountWithin(document); }, { once: true });
  else mountWithin(document);
  document.addEventListener('shopify:section:load', function (event) { mountWithin(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (destroy, root) { if (event.target.contains(root)) destroy(); });
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wing-quiz"]) return;
  try {
    
(function () {
  if (window.__wingQuizInstalled) return;
  window.__wingQuizInstalled = true;
  var cleanup = null;
  function mount() {
    if (cleanup) cleanup();
    var root = document.querySelector('[data-wing-quiz-root]');
    if (!root) return;
    var dialog = root.querySelector('dialog');
    var config = JSON.parse(root.querySelector('[data-wq-config]').textContent);
    var body = root.querySelector('[data-wq-body]');
    var title = root.querySelector('#WingQuizTitle');
    var intro = root.querySelector('[data-wq-intro]');
    var next = root.querySelector('[data-wq-next]');
    var back = root.querySelector('[data-wq-back]');
    var scroll = root.querySelector('[data-wq-scroll]');
    var progress = root.querySelector('[data-wq-progress]');
    var label = root.querySelector('[data-wq-progress-label]');
    var controller = new AbortController();
    var signal = controller.signal;
    var returnFocus = null;
    var priorOverflow = null;
    var storageKey = 'theguideliner-wing-quiz-v1';
    var answers = { shape: '', look: '', drama: '', color: '' };
    var step = 0;
    var questionKeys = ['shape', 'look', 'drama', 'color'];
    var questions = [
      { key: 'shape', title: "What's your eye shape?", intro: 'Look straight into a mirror with your eyes open and relaxed. Compare with photos, then choose the best match.',
        choices: ['Almond','Round','Upturned','Downturned','Hooded','Monolid','Mature'].map(function(s) { return { value:s.toLowerCase(), title:s, description:config.descriptions[s.toLowerCase()], media:'eye_'+s.toLowerCase() }; }) },
      { key: 'look', title: 'What wing type do you like?', intro: 'Pick the one you are leaning towards',
        choices: [{ value:'classic', title:'Classic cat eye', description:'A uplifted flick with uplift', media:'look_classic' }, { value:'blade', title:'Siren eye', description:'A straight, sharp wing', media:'look_blade' }] },
      {
  key: 'drama',
  title: 'Are you a drama queen?',
  intro: 'How much wing is your thing?',
  choices: [
    {
      value: 'small',
      title: 'No, I like a subtle wing',
      description: 'Skinni',
      media: 'drama_small'
    },
    {
      value: 'med',
      title: 'Kinda, inbetween is fine',
      description: 'Middi',
      media: 'drama_med'
    },
    {
      value: 'large',
      title: 'Yes, I want a dramatic wing',
      description: 'Thicci',
      media: 'drama_large'
    }
  ]
},
      { key: 'color', title: "What's your colour vibe?", intro: '',
        choices: [{ value:'black', title:'Black', description:'Bold and defined' }, { value:'brown', title:'Brown', description:'Soft and natural' }] }
    ];
    questions.forEach(function(q) {
      q.choices.push({
        value: 'unsure',
        title: "I'm not sure",
        description: 'Help me explore my options.'
      });
    });
    function hasUnsureAnswer() {
      return questionKeys.some(function(key) { return answers[key] === 'unsure'; });
    }
    try {
      var saved = JSON.parse(sessionStorage.getItem(storageKey));
      if (saved && saved.answers) {
        questions.forEach(function(q) {
          if (q.choices.some(function(c) { return c.value === saved.answers[q.key]; })) answers[q.key] = saved.answers[q.key];
        });
        var incomplete = questionKeys.findIndex(function(k) { return !answers[k]; });
        step = incomplete < 0 ? Math.min(4, Math.max(0, Number(saved.step) || 0)) : incomplete;
      }
    } catch (e) {}
    function save() {
      try { sessionStorage.setItem(storageKey, JSON.stringify({answers:answers,step:step})); } catch (e) {}
    }
    function node(tag, className, text) {
      var el = document.createElement(tag);
      if (className) el.className = className;
      if (text !== undefined && text !== null) el.textContent = text;
      return el;
    }
    function media(key, fallback, optional) {
      var template = root.querySelector('template[data-wq-media="'+key+'"]');
      var content = template && template.content.cloneNode(true);
      var populated = content && content.querySelector('img,video');
      if (!populated && optional) return null;
      var wrap = node('div', 'wq-media');
      if (populated) wrap.appendChild(content);
      else wrap.appendChild(node('span','wq-missing',fallback));
      return wrap;
    }
    function localizedLink(value) {
      var url = new URL(value, location.origin);
      if (url.origin === location.origin) {
        var prefix = (config.root || '/').replace(/\/$/, '');
        if (prefix && url.pathname !== prefix && url.pathname.indexOf(prefix + '/') !== 0) url.pathname = prefix + url.pathname;
      }
      return url.href;
    }
    function link(text, value, cls) {
      var a = node('a', cls || 'wq-primary', text);
      a.href = localizedLink(value);
      return a;
    }
    function renderQuestion(q) {
      var choices = node('fieldset', 'wq-grid wq-grid--'+q.key);
      choices.setAttribute('aria-labelledby','WingQuizTitle');
      q.choices.forEach(function(choice) {
        var option = node('label','wq-option'+(choice.value === 'unsure' ? ' wq-option--unsure' : ''));
        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'wing-quiz-'+q.key;
        input.value = choice.value;
        input.checked = answers[q.key] === choice.value;
        var tick = node('span','wq-tick','✓');
        tick.setAttribute('aria-hidden','true');
        option.append(input,tick);
        if (choice.media) {
          var choiceMediaKey = q.key === 'drama' && answers.look === 'blade' ? 'drama_blade_'+choice.value : choice.media;
          var choiceMedia = media(choiceMediaKey,choice.title+' photo',q.key === 'drama');
          if (choiceMedia) option.appendChild(choiceMedia);
        }
        if (choice.flourish) {
          var flourish = node('span','wq-drama',choice.flourish);
          flourish.setAttribute('aria-hidden','true');
          option.appendChild(flourish);
        }
        if (q.key === 'color' && choice.value !== 'unsure') {
          var swatch = node('span','wq-swatch wq-swatch--'+choice.value);
          swatch.setAttribute('aria-hidden','true');
          option.appendChild(swatch);
        }
        var copy = node('span','wq-option-copy');
        copy.append(node('span','wq-option-title',choice.title),node('span','wq-option-description',choice.description));
        option.appendChild(copy);
        input.addEventListener('change',function() { answers[q.key]=choice.value; next.disabled=false; save(); });
        choices.appendChild(option);
      });
      body.appendChild(choices);
    }
    function hoodedSlideshow() {
      var card = node('section','wq-hooded-technique');
      var heading = node('h3','','Use our The Blink N Snap technique for hooded eyes');
      var gallery = node('div','wq-hooded-gallery');
      gallery.setAttribute('role','region');
      gallery.setAttribute('aria-label','Blink N Snap technique GIFs');
      gallery.tabIndex = 0;
      ['tech_blink','tech_blink_2','tech_blink_3'].forEach(function(key,index) {
        var slide = media(key,'Blink N Snap demonstration '+(index+1),true);
        if (!slide) return;
        var img = slide.querySelector('img');
        if (img && !img.alt) img.alt = 'Blink N Snap technique, demonstration '+(index+1);
        var figure = node('figure','wq-hooded-slide');
        figure.setAttribute('data-gif-slot',String(index+1));
        figure.appendChild(slide);
        if (index === 2) {
          var position = Number(config.hoodedThirdPosition);
          if (!Number.isFinite(position)) position = 40;
          figure.style.setProperty('--wq-gif-position',Math.max(0,Math.min(100,position))+'%');
        }
        var caption = (config.hoodedCaptions || [])[index];
        if (typeof caption === 'string' && caption.trim()) {
          figure.appendChild(node('figcaption','wq-hooded-caption',caption.trim()));
        }
        gallery.appendChild(figure);
      });
      if (!gallery.children.length) return null;
      card.append(heading,gallery);
      return card;
    }
    function renderResult() {
      var key = questionKeys.map(function(k) {return answers[k];}).join('|');
      var unsure = hasUnsureAnswer();
      var recommendation = unsure ? null : config.recommendations[key];
      if (!unsure && !recommendation) {
        step = 0;
        render();
        return;
      }
      if (answers.shape === 'almond' || answers.shape === 'mature') {
        var note = node('aside', 'wq-note wq-note--' + answers.shape);
        note.appendChild(node('p','',answers.shape === 'almond'
          ? "You're super lucky, almond eyes normally suit any style."
          : "Be patient with yourself. There can be a small learning curve, especially if you've never worn eyeliner before. Give yourself time to practice."));
        body.appendChild(note);
      }
      if (recommendation) {
        var guideme = node('section','wq-guideme');
        guideme.append(node('h3','','The GuideMe Kit'),node('p','','A starter kit, with a style we think you’ll love.'));
        var gallery = node('div','wq-result-gallery');
        gallery.setAttribute('role','region');
        gallery.setAttribute('aria-label','Recommended styles: swipe to see each style and its kit button');
        gallery.tabIndex = 0;
        var copies = [];
        [recommendation.first,recommendation.second].forEach(function(style,index) {
          var name = style.size+' in '+style.color.toLowerCase()+' from the '+style.collection+' Collection';
          var mediaKey = [style.collection,style.size,style.color].join('_').toLowerCase();
          var photo = media(mediaKey,name);
          var img = photo.querySelector('img');
          if (img) img.alt = (index === 0 ? 'Best match: ' : 'A close second: ')+name;
          var card = node('article','wq-result-card'+(index === 0 ? ' wq-result-card--best' : ' wq-result-card--second'));
          var copy = node('div','wq-result-copy');
          copy.append(
            node('span','wq-kicker',index === 0 ? 'Best match' : 'A close second'),
            node('h4','',name)
          );
          card.append(photo,copy);
          gallery.appendChild(card);
          copies.push(copy);
        });
        var shopUrl = new URL(localizedLink(config.gmk));
        shopUrl.searchParams.set('wq_source','quiz');
        shopUrl.searchParams.set('wq_color',recommendation.first.color.toLowerCase());
        shopUrl.searchParams.set('wq_collection',recommendation.first.collection.toLowerCase());
        shopUrl.searchParams.set('wq_size',recommendation.first.size.toLowerCase());
        shopUrl.searchParams.set('wq_bundle','single');
        ['wq_second_color','wq_second_collection','wq_second_size'].forEach(function(key) {
          shopUrl.searchParams.delete(key);
        });
        copies[0].appendChild(link('Add to GuideMe Kit',shopUrl.href,'wq-primary wq-shop-gmk'));
        var duoUrl = new URL(shopUrl.href);
        duoUrl.searchParams.set('wq_bundle','duo');
        duoUrl.searchParams.set('wq_second_color',recommendation.second.color.toLowerCase());
        duoUrl.searchParams.set('wq_second_collection',recommendation.second.collection.toLowerCase());
        duoUrl.searchParams.set('wq_second_size',recommendation.second.size.toLowerCase());
        copies[1].appendChild(node('p','wq-duo-prompt',''));
        copies[1].appendChild(link('Add both to GuideMe Kit',duoUrl.href,'wq-primary wq-shop-gmk wq-shop-duo'));
        guideme.appendChild(gallery);
        body.appendChild(guideme);
      }
      if (answers.shape === 'monolid') {
        var monolidTemplate = root.querySelector('[data-wq-monolid]');
        if (monolidTemplate) body.appendChild(monolidTemplate.content.cloneNode(true));
      }
      if (answers.shape === 'hooded' || answers.shape === 'mature') {
        var slideshow = hoodedSlideshow();
        if (slideshow) body.appendChild(slideshow);
      }
      var tryme = node(unsure ? 'section' : 'aside','wq-tryme'+(unsure ? ' wq-tryme--recommended' : ''));
      tryme.appendChild(media('tryme','The TryMe Kit'));
      var trymeCopy = node('div','');
      trymeCopy.append(
        node('h3','',unsure ? 'The TryMe Kit' : 'Want to try every style?'),
        node('p','',unsure
          ? "Not sure yet? The TryMe Kit lets you try every wing style and discover your favourites, without choosing just one."
          : 'The TryMe Kit lets you explore every style and discover your favourites.'),
        link('Grab the TryMe Kit',config.tmk)
      );
      tryme.appendChild(trymeCopy);
      if (unsure) body.prepend(tryme); else body.appendChild(tryme);
      var extras = node('div','wq-secondary-links');
      extras.appendChild(link('Returning customer? Shop here',config.refill,'wq-text-link'));
      var team = node('p','','Buying for a dance or cheer team? ');
      team.appendChild(link('Shop wholesale',config.team,'wq-text-link'));
      extras.appendChild(team);
      body.appendChild(extras);
    }
    function render() {
      body.querySelectorAll('video').forEach(function(v) { v.pause(); });
      body.replaceChildren();
      var result = step === 4;
      title.textContent = result ? (hasUnsureAnswer() ? 'Find your perfect wing' : 'Meet your perfect wings') : questions[step].title;
      intro.hidden = result;
      intro.textContent = result ? '' : questions[step].intro;
      if (!result && questions[step].key === 'drama') {
        intro.textContent = 'How much wing is your thing?';
      }
      label.textContent = result ? (hasUnsureAnswer() ? 'Your recommended kit' : 'Your personalised picks') : 'Question '+(step+1)+' of 4';
      progress.value = result ? 4 : step+1;
      back.hidden = step === 0;
      back.textContent = result ? 'Edit answers' : 'Back';
      next.textContent = result ? 'Retake quiz' : step === 3 ? 'Show my matches →' : 'Next question →';
      next.disabled = !result && !answers[questionKeys[step]];
      if (result) renderResult(); else renderQuestion(questions[step]);
      scroll.scrollTop = 0;
      save();
      if (dialog.open) title.focus({preventScroll:true});
    }
    function release() {
      body.querySelectorAll('video').forEach(function(v) { v.pause(); });
      if (priorOverflow !== null) document.body.style.overflow = priorOverflow;
      priorOverflow = null;
      if (returnFocus && returnFocus.isConnected) returnFocus.focus({preventScroll:true});
    }
    document.addEventListener('click',function(event) {
      var trigger = event.target.closest('[data-wing-quiz-open]');
      if (!trigger) return;
      event.preventDefault();
      if (dialog.open) return;
      returnFocus = trigger;
      priorOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
      render();
    },{signal:signal});
    root.querySelector('[data-wq-close]').addEventListener('click',function(){dialog.close();},{signal:signal});
    dialog.addEventListener('close',release,{signal:signal});
    dialog.addEventListener('click',function(e) { if (e.target===dialog) {
      var rect=dialog.getBoundingClientRect();
      if(e.clientX<rect.left || e.clientX>rect.right || e.clientY<rect.top || e.clientY>rect.bottom) dialog.close();
    } },{signal:signal});
    next.addEventListener('click',function(){
      if(step===4){answers={shape:'',look:'',drama:'',color:''};step=0;}
      else if(answers[questionKeys[step]])step++;
      render();
    },{signal:signal});
    back.addEventListener('click',function(){step=Math.max(0,step-1);render();},{signal:signal});
    cleanup=function(){if(dialog.open)dialog.close();release();controller.abort();};
    if (new URLSearchParams(window.location.search).get('wing_quiz') === '1' && !dialog.open) {
  returnFocus = document.querySelector('[data-wing-quiz-open]');
  priorOverflow = document.body.style.overflow;
  dialog.showModal();
  document.body.style.overflow = 'hidden';
  render();
}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
  document.addEventListener('shopify:section:load',function(e){if(e.target.querySelector('[data-wing-quiz-root]'))mount();});
  document.addEventListener('shopify:section:unload',function(e){if(e.target.querySelector('[data-wing-quiz-root]') && cleanup){cleanup();cleanup=null;}});
})();

  } catch(e) { console.error(e); }
})();
})();
